import IntegrationCard from './IntegrationCard'

export default IntegrationCard
